import { locationIdFromParts } from '@lib.core/location/location-id';
import { ProfileAspect } from '@lib.core/entities/profile/profile-aspect';
import { ProfileAspectCollection } from '@lib.core/entities/profile/profile-aspect-collection';
import { AspectSummaryDTO } from '@lib.resources/indicator/dtos/indicator-summary';
import { LocationDTO } from '@lib.resources/location/dtos/location';
import { PagedDTO } from '@lib.resources/utils/paged';

export interface ProfileAspectContextDTO {
  location?: LocationDTO;
  sectorId?: number;
  industryId?: number;
  occupationId?: number;
  productId?: number;
}

export interface ProfileAspectDTO {
  aspectNameid: string;
  context?: ProfileAspectContextDTO;
  aspectSummary: AspectSummaryDTO;
}

export type ProfileAspectCollectionDTO = PagedDTO<ProfileAspectDTO>;

function locationNameIdFromDTO(location?: LocationDTO): string | undefined {
  if (!location?.countryCode) {
    return undefined;
  }
  return locationIdFromParts(location.countryCode, location.geoType, location.geoCode);
}

export function newProfileAspectFromDTO(dto: ProfileAspectDTO): ProfileAspect {
  const { aspectNameid, context, aspectSummary } = dto;
  return {
    aspectNameId: aspectNameid,
    locationNameId: locationNameIdFromDTO(context?.location),
    sectorId: context?.sectorId,
    industryId: context?.industryId,
    occupationId: context?.occupationId,
    productId: context?.productId,
    aspectSummary: AspectSummaryDTO.toAspectSummary(aspectSummary),
  };
}

export function newProfileAspectCollectionFromDTO(dto: ProfileAspectCollectionDTO): ProfileAspectCollection {
  const { items, total, pageSize, currentPage } = dto;
  return {
    items: items.map((item) => newProfileAspectFromDTO(item)),
    total,
    pageSize,
    currentPage,
  };
}
